module.exports = __webpack_public_path__ + "static/media/a14.ebb73554.pdf";